import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EditTransliteration from "./EditTransliteration";
import DatePicker from "react-datepicker";
import moment from "moment";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";

const EditInterDistrictTransfer = () => {
  const route = useParams().id;
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const userId = localStorage.getItem("userId");

  const [IDTData, setIDTData] = useState([]);
  const getIDTData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/get-inter_district_transfer-data`,
        {
          method: "POST",
          body: JSON.stringify({
            userId,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        let singleData = result.result.find((item) => item._id === route);
        setIDTData(singleData);
      } else {
        setIDTData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getIDTData();
  }, [userId]);

  const tabs = ["Form 1", "Form 2"];
  const [formData, setFormData] = useState({
    fullName: "",
    designation: "",
    officeName: "",
    currentDistrict: "",
    hodDesignation: "",
    officerDesignation: "",
    transferDistrict: "",
    permanantAddress: "",
    district: "",
    birthDateNumber: new Date(),
    birthDateWords: "",
    education: "",
    casteCategory: "",
    reservationType: "",
    currentPost: "",
    currentPostDate: new Date(),
    firstAppointmentOffice: "",
    firstAppointmentDesig: "",
    appointmentDate: "",
    serviceDuration: "",
    salaryRange: "",
    baseSalary: "",
    gpfApplicable: "",
    gpfNumber: "",
    transferReason: "",
  });
  const [formData2, setFormData2] = useState({
    fullName: "",
    designation: "",
    officeName: "",
    currentDistrict: "",
    hodDesignation: "",
    officerDesignation: "",
    transferDistrict: "",
    permanantAddress: "",
    district: "",
    birthDateNumber: new Date(),
    birthDateWords: "",
    education: "",
    casteCategory: "",
    reservationType: "",
    currentPost: "",
    currentPostDate: new Date(),
    firstAppointmentOffice: "",
    firstAppointmentDesig: "",
    appointmentDate: "",
    serviceDuration: "",
    salaryRange: "",
    baseSalary: "",
    gpfApplicable: "",
    gpfNumber: "",
    transferReason: "",
  });

  const handleInputChange = (name, marathiValue, englishValue) => {
    if (name === "gpfNumber" || name === "baseSalary") {
      setFormData((prev) => ({
        ...prev,
        [name]: englishValue, // Marathi EditTransliteration
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: marathiValue, // Marathi EditTransliteration
      }));
    }
    setFormData2((prev) => ({
      ...prev,
      [name]: englishValue, // English input
    }));
  };

  const numberToWords = (num) => {
    const words = [
      "",
      "First",
      "Second",
      "Third",
      "Fourth",
      "Fifth",
      "Sixth",
      "Seventh",
      "Eighth",
      "Ninth",
      "Tenth",
      "Eleventh",
      "Twelfth",
      "Thirteenth",
      "Fourteenth",
      "Fifteenth",
      "Sixteenth",
      "Seventeenth",
      "Eighteenth",
      "Nineteenth",
      "Twentieth",
      "Twenty-first",
      "Twenty-second",
      "Twenty-third",
      "Twenty-fourth",
      "Twenty-fifth",
      "Twenty-sixth",
      "Twenty-seventh",
      "Twenty-eighth",
      "Twenty-ninth",
      "Thirtieth",
      "Thirty-first",
    ];
    return words[num] || num.toString();
  };

  const yearToWords = (year) => {
    const parts = String(year).split("");
    const words = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const tensWords = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    return `${words[parts[0]]} Thousand ${tensWords[parts[2]]} ${
      words[parts[3]]
    }`;
  };

  const convertDateToText = (dateString) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Parse the input date
    const [day, month, year] = dateString.split("-");
    const dayText = numberToWords(parseInt(day, 10));
    const monthText = months.find((m) => m.startsWith(month));
    const yearText = yearToWords(year);

    return `${dayText} ${monthText} ${yearText}`;
  };

  const handleInputDOBDateChange = (value) => {
    const textDate = convertDateToText(moment(value).format("DD-MMM-YYYY"));
    setFormData((prevData) => ({
      ...prevData,
      ["birthDateNumber"]: moment(value).format("DD-MMM-YYYY"),
      ["birthDateWords"]: textDate,
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["birthDateNumber"]: moment(value).format("DD-MMM-YYYY"),
      ["birthDateWords"]: textDate,
    }));
  };

  const handleInputAppoDateChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      ["appointmentDate"]: moment(value).format("DD-MMM-YYYY"),
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["appointmentDate"]: moment(value).format("DD-MMM-YYYY"),
    }));
  };

  const handleCurrentPostDate = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      ["currentPostDate"]: moment(value).format("DD-MMM-YYYY"),
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["currentPostDate"]: moment(value).format("DD-MMM-YYYY"),
    }));
  };

  useEffect(() => {
    const duration = calculateServiceDuration(formData.appointmentDate);
    setFormData((prevData) => ({
      ...prevData,
      serviceDuration: duration,
    }));
  }, [formData.appointmentDate]);

  // Function to calculate service duration
  const calculateServiceDuration = (appointmentDate) => {
    if (!appointmentDate) return "";

    const startDate = new Date(appointmentDate);
    const endDate = new Date(); // Current date

    const years = endDate.getFullYear() - startDate.getFullYear();
    const months = endDate.getMonth() - startDate.getMonth();
    const days = endDate.getDate() - startDate.getDate();

    let adjustedMonths = months;
    let adjustedDays = days;

    if (days < 0) {
      adjustedMonths -= 1;
      adjustedDays += new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        0
      ).getDate(); // Days in previous month
    }

    if (months < 0) {
      adjustedMonths += 12;
    }

    return `${years} वर्ष, ${adjustedMonths} महिने, ${adjustedDays} दिवस`;
  };

  const [salarySlip, setSalarySlip] = useState({
    salaryDate: new Date(),
    basicPay: "",
    dearnessAllowance: "",
    houseRentAllowance: "",
    transportAllowance: "",
    cityAllowance: "",
    dearnessDifference: "",
    other1: "",
    grossPayableSalary: "",
    professionTax: "",
    groupInsurance: "",
    bhininiVargani: "",
    festivalAdvance: "",
    lic: "",
    gppatSanstha: "",
    receiptTicket: "",
    totalDeductions: "",
    netPaySalary: "",
  });
  const [toDate, setToDate] = useState(new Date());
  const handleSalaryDateChange = (value) => {
    setToDate(moment(value).format("MMM-YYYY"));
    setSalarySlip((prevData) => ({
      ...prevData,
      ["salaryDate"]: moment(value).format("MMM-YYYY"),
    }));
  };

  useEffect(() => {
    try {
      if (IDTData?.formData) {
        setFormData(JSON.parse(IDTData.formData));
      }
      if (IDTData?.formData2) {
        setFormData2(JSON.parse(IDTData.formData2));
      }
      if (IDTData?.salarySlip) {
        setSalarySlip(JSON.parse(IDTData.salarySlip));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [IDTData]);

  const handleChangee = (e) => {
    const { name, value } = e.target;
    setSalarySlip({ ...salarySlip, [name]: value });
  };
  const calculateGrossPayableSalary = () => {
    const fields = [
      "basicPay",
      "dearnessAllowance",
      "houseRentAllowance",
      "transportAllowance",
      "cityAllowance",
      "permanentTravelAllowance",
      "nps",
      "dearnessDifference",
      "other1",
    ];
    return fields.reduce(
      (total, field) => total + parseFloat(salarySlip[field] || 0),
      0
    );
  };

  const calculateTotalDeductions = () => {
    const fields = [
      "professionTax",
      "groupInsurance",
      "bhininiVargani",
      "festivalAdvance",
      "dcps",
      "npsDeduction",
      "lic",
      "gppatSanstha",
      "receiptTicket",
    ];
    return fields.reduce(
      (total, field) => total + parseFloat(salarySlip[field] || 0),
      0
    );
  };

  const calculateNetPay = () => {
    const grossPayableSalary = calculateGrossPayableSalary();
    const totalDeductions = calculateTotalDeductions();
    return grossPayableSalary - totalDeductions;
  };

  useEffect(() => {
    const grossPayableSalary = calculateGrossPayableSalary();
    const totalDeductions = calculateTotalDeductions();
    const netPaySalary = grossPayableSalary - totalDeductions;

    setSalarySlip({
      ...salarySlip,
      grossPayableSalary,
      totalDeductions,
      netPaySalary,
    });
  }, [
    salarySlip.basicPay,
    salarySlip.dearnessAllowance,
    salarySlip.houseRentAllowance,
    salarySlip.transportAllowance,
    salarySlip.cityAllowance,
    salarySlip.dearnessDifference,
    salarySlip.other1,
    salarySlip.grossPayableSalary,
    salarySlip.professionTax,
    salarySlip.groupInsurance,
    salarySlip.bhininiVargani,
    salarySlip.festivalAdvance,
    salarySlip.lic,
    salarySlip.gppatSanstha,
    salarySlip.receiptTicket,
    salarySlip.nps,
    salarySlip.dcps,
    salarySlip.npsDeduction,
  ]);

  const updateInterDistrictTransfer = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/update-inter_district_transfer-data`,
        {
          method: "POST",
          body: JSON.stringify({
            data_id: route,
            formData,
            formData2,
            salarySlip,
            empName: formData.fullName,
            gpfNumber: formData.gpfNumber,
            officeName: formData.officeName,
            empDesignation: formData.designation,
            currentDistrict: formData.currentDistrict,
            transferDistrict: formData.transferDistrict,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        toast.success(result.message);
        navigate("/dashboard/inter_district_transfer_work");
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      alert(error);
    }
  };

  return (
    <div className="inter-district-transfer p-6">
      <div className="row">
        <div className="col-lg-10">
          <div className="max-w-4xl mx-auto p-4 mt-3 bg-info rounded-md shadow-xl gpfnr-input">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="text-xl fw-bold text-primary text-center">
                  आंतर जिल्हा बदलीचा प्रस्ताव
                </h2>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row border-b-2 gap-3 my-3">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentStep(index)}
                  className={` py-2 px-4 text-xs sm:text-sm w-25 font-semibold text-center 
              ${
                currentStep === index
                  ? "bg-teal-600 text-white"
                  : "bg-orange-100 text-gray-800"
              }
              hover:bg-teal-600 hover:text-white transition-all`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {currentStep === 0 && (
              <>
                <div className="card px-2 py-4">
                  <div className="row g-2">
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          अर्जदाराचे संपूर्ण नाव
                        </label>
                        <EditTransliteration
                          name="fullName"
                          fromDataEnglish={formData2.fullName}
                          fromDataMarathi={formData.fullName}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          पदनाव
                        </label>
                        <EditTransliteration
                          name="designation"
                          fromDataEnglish={formData2.designation}
                          fromDataMarathi={formData.designation}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          कार्यालय प्रमुखाचे पदनाम
                        </label>
                        <EditTransliteration
                          name="officerDesignation"
                          fromDataEnglish={formData2.officerDesignation}
                          fromDataMarathi={formData.officerDesignation}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          विभाग प्रमुखाचे पदनाम
                        </label>
                        <EditTransliteration
                          name="hodDesignation"
                          fromDataEnglish={formData2.hodDesignation}
                          fromDataMarathi={formData.hodDesignation}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          कार्यालयाचे नाव
                        </label>
                        <EditTransliteration
                          name="officeName"
                          fromDataEnglish={formData2.officeName}
                          fromDataMarathi={formData.officeName}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          जिल्हा परिषदेचे नाव
                        </label>
                        <EditTransliteration
                          name="currentDistrict"
                          fromDataEnglish={formData2.currentDistrict}
                          fromDataMarathi={formData.currentDistrict}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          कोणत्या जिल्हा परिषदेत बदली करावयाची आहे
                        </label>
                        <EditTransliteration
                          name="transferDistrict"
                          fromDataEnglish={formData2.transferDistrict}
                          fromDataMarathi={formData.transferDistrict}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          कायम राहत असलेल्या गावाचे नाव व पत्ता
                        </label>
                        <EditTransliteration
                          name="permanantAddress"
                          fromDataEnglish={formData2.permanantAddress}
                          fromDataMarathi={formData.permanantAddress}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          कायम राहत असलेल्या जिल्हा
                        </label>
                        <EditTransliteration
                          name="district"
                          fromDataEnglish={formData2.district}
                          fromDataMarathi={formData.district}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-12 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          जन्म तारीख अंकी
                        </label>
                        <DatePicker
                          selected={formData.birthDateNumber}
                          onChange={(date) => handleInputDOBDateChange(date)}
                          dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                          className="form-control w-100"
                          showMonthDropdown // Enables month dropdown
                          showYearDropdown // Enables year dropdown
                          dropdownMode="select" // Allows selection instead of scrolling
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-12 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-1">
                        जन्म तारीख अक्षरी:
                      </label>
                      <input
                        className="form-control"
                        value={formData.birthDateWords}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="card px-2 py-4 mt-3">
                  <div className="row g-2">
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          शैक्षणिक पात्रता
                        </label>
                        <EditTransliteration
                          name="education"
                          fromDataEnglish={formData2.education}
                          fromDataMarathi={formData.education}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-1">
                          जात व प्रवर्ग
                        </label>
                        <EditTransliteration
                          name="casteCategory"
                          fromDataEnglish={formData2.casteCategory}
                          fromDataMarathi={formData.casteCategory}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        सध्या धारण केलेले पद
                      </label>
                      <EditTransliteration
                        name="currentPost"
                        fromDataEnglish={formData2.currentPost}
                        fromDataMarathi={formData.currentPost}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-lg-3 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        सध्या धारण पदाची तारीख
                      </label>
                      <DatePicker
                        selected={formData.currentPostDate}
                        onChange={(date) => handleCurrentPostDate(date)}
                        dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                        className="form-control"
                        showMonthDropdown // Enables month dropdown
                        showYearDropdown // Enables year dropdown
                        dropdownMode="select" // Allows selection instead of scrolling
                      />
                    </div>

                    <div className="col-lg-3 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        प्रथम नेमणूक दिनांक
                      </label>
                      <DatePicker
                        selected={formData.appointmentDate}
                        onChange={(date) => handleInputAppoDateChange(date)}
                        dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                        className="form-control w-100"
                        showMonthDropdown // Enables month dropdown
                        showYearDropdown // Enables year dropdown
                        dropdownMode="select" // Allows selection instead of scrolling
                      />
                    </div>
                    <div className="col-lg-6 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        प्रथम नेमणूक कार्यालय
                      </label>
                      <EditTransliteration
                        name="firstAppointmentOffice"
                        fromDataEnglish={formData2.firstAppointmentOffice}
                        fromDataMarathi={formData.firstAppointmentOffice}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-lg-6 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        प्रथम नेमणूक पदनाम
                      </label>
                      <EditTransliteration
                        name="firstAppointmentDesig"
                        fromDataEnglish={formData2.firstAppointmentDesig}
                        fromDataMarathi={formData.firstAppointmentDesig}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-lg-3 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        आज रोजी झालेली सेवा
                      </label>
                      <input
                        name="serviceDuration"
                        value={formData.serviceDuration}
                        readOnly
                        className="form-control"
                      />
                    </div>
                    <div className="col-lg-3 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        वेतन श्रेणी
                      </label>
                      <select
                        id="salaryRange"
                        name="salaryRange"
                        onChange={(e) =>
                          handleInputChange(
                            "salaryRange",
                            e.target.value,
                            e.target.value
                          )
                        }
                        className="form-control form-select"
                        required
                      >
                        <option value={formData.salaryRange}>
                          {formData.salaryRange}
                        </option>
                        <option value="S-1 : 15000-47600">
                          S-1 : 15000-47600
                        </option>
                        <option value="S-2 : 15300-48700">
                          S-2 : 15300-48700
                        </option>
                        <option value="S-3 : 16600-52400">
                          S-3 : 16600-52400
                        </option>
                        <option value="S-4 : 17100-54000">
                          S-4 : 17100-54000
                        </option>
                        <option value="S-5 : 18000-56900">
                          S-5 : 18000-56900
                        </option>
                        <option value="S-6 : 19900-63200">
                          S-6 : 19900-63200
                        </option>
                        <option value="S-7 : 21700-69100">
                          S-7 : 21700-69100
                        </option>
                        <option value="S-8 : 25500-81100">
                          S-8 : 25500-81100
                        </option>
                        <option value="S-9 : 26400-83600">
                          S-9 : 26400-83600
                        </option>
                        <option value="S-10 : 29200-92300">
                          S-10 : 29200-92300
                        </option>
                        <option value="S-11 : 30100-95100">
                          S-11 : 30100-95100
                        </option>
                        <option value="S-12 : 32000-101600">
                          S-12 : 32000-101600
                        </option>
                        <option value="S-13 : 35400-112400">
                          S-13 : 35400-112400
                        </option>
                        <option value="S-14 : 38600-122800">
                          S-14 : 38600-122800
                        </option>
                        <option value="S-15 : 41800-132300">
                          S-15 : 41800-132300
                        </option>
                        <option value="S-16 : 44900-142400">
                          S-16 : 44900-142400
                        </option>
                        <option value="S-17 : 47600-151100">
                          S-17 : 47600-151100
                        </option>
                        <option value="S-18 : 49100-155800">
                          S-18 : 49100-155800
                        </option>
                        <option value="S-19 : 55100-175100">
                          S-19 : 55100-175100
                        </option>
                        <option value="S-20 : 56100-177500">
                          S-20 : 56100-177500
                        </option>
                        <option value="S-21 : 57100-180800">
                          S-21 : 57100-180800
                        </option>
                        <option value="S-22 : 60000-190800">
                          S-22 : 60000-190800
                        </option>
                        <option value="S-23 : 67700-208700">
                          S-23 : 67700-208700
                        </option>
                        <option value="S-24 : 71100-211900">
                          S-24 : 71100-211900
                        </option>
                        <option value="S-25 : 78800-209200">
                          S-25 : 78800-209200
                        </option>
                        <option value="S-27 : 118500-214100">
                          S-27 : 118500-214100
                        </option>
                        <option value="S-28 : 124800-212400">
                          S-28 : 124800-212400
                        </option>
                        <option value="S-29 : 131100-216600">
                          S-29 : 131100-216600
                        </option>
                      </select>
                    </div>
                    <div className="col-lg-3 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        मूळ वेतन
                      </label>
                      <input
                        type="number"
                        name="baseSalary"
                        value={formData.baseSalary}
                        onChange={(e) =>
                          handleInputChange(
                            "baseSalary",
                            e.target.value,
                            e.target.value
                          )
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-lg-3 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        पदाचे स्वरूप
                      </label>
                      <select
                        id="postType"
                        name="postType"
                        className="form-control form-select"
                        onChange={(e) =>
                          handleInputChange(
                            "postType",
                            e.target.value,
                            e.target.value
                          )
                        }
                      >
                        <option value={formData.postType}>
                          {formData.postType}
                        </option>
                        <option value={"स्थायी"}>स्थायी</option>
                        <option value={"तात्पुरती"}>तात्पुरती</option>
                      </select>
                    </div>

                    <div className="col-lg-3 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        GPF/Pension लागू आहे काय?
                      </label>
                      <select
                        id="gpfApplicable"
                        name="gpfApplicable"
                        className="form-control form-select"
                        onChange={(e) =>
                          handleInputChange(
                            "gpfApplicable",
                            e.target.value,
                            e.target.value
                          )
                        }
                      >
                        <option value={formData.gpfApplicable}>
                          {formData.gpfApplicable}
                        </option>
                        <option value={"होय"}>होय</option>
                        <option value={"नाही"}>नाही</option>
                      </select>
                    </div>
                    <div className="col-lg-2 col-6 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        भ. नि. नि. क्र.
                      </label>
                      <input
                        type="text"
                        name="gpfNumber"
                        value={formData.gpfNumber}
                        onChange={(e) =>
                          handleInputChange(
                            "gpfNumber",
                            e.target.value,
                            e.target.value
                          )
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-lg-7 col-12 mt-2">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        बदलीचे कारण
                      </label>
                      <EditTransliteration
                        name="transferReason"
                        fromDataEnglish={formData2.transferReason}
                        fromDataMarathi={formData.transferReason}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {currentStep === 1 && (
              <div className="card p-4">
                <div className="row mb-3">
                  <div className="col-lg-8 col-12 mt-lg-0 mt-3 ps-0">
                    <h1 className="text-left text-red-600 text-xl font-bold mb-4">
                      वेतन प्रमाणपत्र (Pay Slip)
                    </h1>
                  </div>
                  <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                    <div className="d-flex align-items-center">
                      <p className="d-flex text-danger fw-bold w-50">
                        महिना :-{" "}
                      </p>
                      <DatePicker
                        selected={salarySlip.salaryDate}
                        onChange={(date) => handleSalaryDateChange(date)}
                        dateFormat="MMM-yyyy" // Built-in format for DD-MMM-YYYY
                        className="form-control"
                        showMonthDropdown // Enables month dropdown
                        showYearDropdown // Enables year dropdown
                        dropdownMode="select" // Allows selection instead of scrolling
                        showMonthYearPicker // Enables Month-Year Picker
                        showFullMonthYearPicker // Optional: Shows full month and year in the dropdown
                      />
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Left Column */}
                  <div className="flex flex-col gap-2">
                    {[
                      { label: "मूळ वेतन", name: "basicPay" },
                      { label: "महागाई भत्ता", name: "dearnessAllowance" },
                      { label: "घरभाडे", name: "houseRentAllowance" },
                      { label: "वाहतूक भत्ता", name: "transportAllowance" },
                      {
                        label: "शहर भत्ता",
                        name: "cityAllowance",
                      },
                      { label: "NPS", name: "nps" },
                      { label: "महागाई भत्ता फरक", name: "dearnessDifference" },
                      { label: "Other-1", name: "other1" },
                      {
                        label: "एकूण देय वेतन",
                        name: "grossPayableSalary",
                        isHighlighted: true,
                      },
                    ].map(({ label, name, isHighlighted }) => (
                      <div
                        key={name}
                        className="flex justify-between items-center gap-4"
                      >
                        <label
                          className={`text-sm font-semibold ${
                            isHighlighted ? "text-red-600" : ""
                          }`}
                        >
                          {label}
                        </label>
                        <input
                          type="text"
                          style={{ fontFamily: "Arial", fontSize: "16px" }}
                          name={name}
                          value={
                            name === "grossPayableSalary"
                              ? calculateGrossPayableSalary()
                              : salarySlip[name]
                          }
                          onChange={handleChangee}
                          className="form-control w-24 sm:w-32 md:w-40"
                          placeholder="Enter value"
                          readOnly={name === "grossPayableSalary"}
                        />
                      </div>
                    ))}
                  </div>

                  {/* Right Column */}
                  <div className="flex flex-col gap-2">
                    {[
                      { label: "व्यवसाय कर", name: "professionTax" },
                      { label: "गट विमा", name: "groupInsurance" },
                      { label: "भ.नि.नि. वर्गणी", name: "bhininiVargani" },
                      { label: "सण अग्रिम", name: "festivalAdvance" },
                      { label: "DCPS", name: "dcps" },
                      { label: "NPS (कपात)", name: "npsDeduction" },
                      { label: "एल आय सी", name: "lic" },
                      { label: "जी प पतसंस्था", name: "gppatSanstha" },
                      { label: "रशीद तिकीट", name: "receiptTicket" },
                      {
                        label: "एकूण कपात वेतन",
                        name: "totalDeductions",
                        isHighlighted: true,
                      },
                      {
                        label: "निव्वळ देय वेतन",
                        name: "netPaySalary",
                        isHighlighted: true,
                      },
                    ].map(({ label, name, isHighlighted }) => (
                      <div
                        key={name}
                        className="flex justify-between items-center gap-4"
                      >
                        <label
                          className={`text-sm font-semibold ${
                            isHighlighted ? "text-red-600" : ""
                          }`}
                        >
                          {label}
                        </label>
                        <input
                          type="text"
                          name={name}
                          style={{ fontFamily: "Arial", fontSize: "16px" }}
                          value={
                            name === "netPaySalary"
                              ? calculateNetPay()
                              : name === "totalDeductions"
                              ? calculateTotalDeductions()
                              : salarySlip[name]
                          }
                          onChange={handleChangee}
                          className="form-control w-24 sm:w-32 md:w-40"
                          placeholder="Enter value"
                          readOnly={
                            name === "netPaySalary" ||
                            name === "totalDeductions"
                          }
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-between mt-4">
              <button
                onClick={() => setCurrentStep((prev) => Math.max(prev - 1, 0))}
                disabled={currentStep === 0}
                className="bg-blue-300 text-gray-800 px-4 py-2 rounded-lg disabled:opacity-50"
              >
                मागील
              </button>
              {currentStep === tabs.length - 1 ? (
                <button
                  onClick={() => updateInterDistrictTransfer()}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                  Save
                </button>
              ) : (
                <button
                  onClick={() =>
                    setCurrentStep((prev) =>
                      Math.min(prev + 1, tabs.length - 1)
                    )
                  }
                  disabled={currentStep === tabs.length - 1}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                  पुढे
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditInterDistrictTransfer;
